import { useQuery } from '@hooks/reactQuery';

import { getConfigurationTemplateConfigTimestamps } from '@api/configurationTemplates';

import { extractQueryParams } from '@utils/common';
import { formatAvailableTimestamps } from '@components/routes/AdminPanel/ManageNetworkElementConfigurations/utils';

import { IConfigurationTemplateTimestampsDTO } from '@interfaces/cmModule/dto/configurationTemplatesDTO';
import { IAvailableTimestamps } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONFIGURATION_TEMPLATES_CONFIG_TIMESTAMPS } from '@constants/queryKeys';

interface IUseQueryNetworkElementConfigurationTimestampsReturned {
	configTimestamps: TSelectOption<number>[];
	isLoadingConfigTimestamps: boolean;
}

const useQueryConfigurationTemplatesConfigTimestamps = (
	params: Partial<IConfigurationTemplateTimestampsDTO<string>>,
): IUseQueryNetworkElementConfigurationTimestampsReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<IAvailableTimestamps[], TSelectOption<number>[]>({
		queryKey: [CONFIGURATION_TEMPLATES_CONFIG_TIMESTAMPS, params],
		queryFn: extractQueryParams(getConfigurationTemplateConfigTimestamps),
		select: formatAvailableTimestamps,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		enabled: [
			!!params.configType,
			!!params.networkElementId,
			!!params.configDate,
		],
		...refetchOptions,
	});

	return {
		configTimestamps: data || [],
		isLoadingConfigTimestamps: isInitialLoading,
	};
};

export default useQueryConfigurationTemplatesConfigTimestamps;
